export enum EGlobalRoles {
  GUEST  = 'GUEST',
  MEMBER = 'MEMBER',
  SUPER_ADMIN = 'SUPER_ADMIN',
  TEAM_VIEWER = 'TEAM_VIEWER',
  TEAM_TAG_MANAGER = 'TEAM_TAG_MANAGER',
};
